"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.manifest = void 0;
// @ts-noCheck
var _1 = require("./");
exports.manifest = {
    schema: _1.schema,
    implements: [],
};
//# sourceMappingURL=manifest.js.map